import styled from "styled-components";
import {colors} from "../../../../common/components/colors";

export const Bar = styled.div`
    width: 100%;
    height: 1px;
    border-bottom: 1px dashed ${colors.secondary30};
`;